import { HttpErrorResponse } from '@angular/common/http';

import type { IntelligenceSettingsState } from '@core/intelligence-types';
import { createSingleEntityStore, getSingleEntityActions, PickActions } from '@core/ngrx-legacy';

const {
  actions,
  reducer: IntelligenceSettingsReducer,
  selectors: IntelligenceSettingsSelectors,
  namespace: IntelligenceSettingsNamespace,
} = createSingleEntityStore<IntelligenceSettingsState>()('IntelligenceSettingsState', {
  customActions: adapter => {
    const defaultActions = getSingleEntityActions(adapter);
    return {
      toggleFeature: (state, payload: Partial<Record<keyof IntelligenceSettingsState, boolean>>) =>
        adapter.markAsPending(state),
      toggleFeatureSuccess: (state, payload: IntelligenceSettingsState) =>
        defaultActions.updateSuccess(state, payload),
      toggleFeatureFailed: (state, payload: HttpErrorResponse) =>
        defaultActions.updateFailed(state, payload),
    };
  },
});

const IntelligenceSettingsActions: PickActions<typeof actions, 'toggleFeature' | 'fetch'> = actions;

export {
  IntelligenceSettingsActions,
  IntelligenceSettingsReducer,
  IntelligenceSettingsSelectors,
  IntelligenceSettingsNamespace,
};
